import React from "react";

function Missing() {
  return (
    <div>
      <h1>404</h1>
      <p>Resource not found</p>
    </div>
  );
}

export default Missing;
